import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box } from '@mui/material';
import PaymentPage from './PaymentPage';
import PlanSelectionPage from './PlanSelectionPage';
import useSubscriptionPlanCheckout from './hooks/useSubscriptionPlanCheckout';
import CheckoutStepper from './CheckoutStepper';
import ReviewPurchasePage from './ReviewPurchasePage';
import Footer from '../../common/components/Footer';
import Checkout from './Checkout';
import SuccessDialog from './SuccessDialog';
import FailureDialog from '../../common/components/FailureDialog';

export default function SubscriptionPlanCheckout() {
    const {
        isHeadCoach,
        handlePaymentPreview,
        handleDowngrade,
        successMessage,
        maxAthleteCount,
        initialPlanSummary,
        finalPlanSummary,
        isLoadingSubscriptionOptions,
        subscriptionOptions,
        currentPlan,
        selectedPlan,
        setSelectedPlan,
        hasErrorLoadingOptions,
        setHasErrorLoadingOptions,
        clientToken,
        isLoadingBraintreeDropIn,
        setBraintreeInstance,
        steps,
        activeStep,
        handleBack,
        handleReviewPurchase,
        handlePurchase,
        isReviewPurchaseLoading,
        isPaymentProcessing,
        shouldShowSuccessDialog,
        handleSuccessDialogClose,
        errorMessage,
        hasCreatePaymentMethodFailure,
        clearServerError,
        hasServerError,
        serverErrorTitle,
        serverErrorMessage,
        clearBraintreeErrorMessage
    } = useSubscriptionPlanCheckout();

    if (!isHeadCoach) {
        return <Redirect to="/" />;
    }


    return (
        <>
            <Box className="outer-container with-nav">
                <Box marginTop={6} alignSelf="center" width="100%" maxWidth="sm">
                    <CheckoutStepper steps={steps} activeStep={activeStep} />
                </Box>
                <Checkout selectedStep={activeStep}>
                    <PlanSelectionPage
                        handlePaymentPreview={handlePaymentPreview}
                        handleDowngrade={handleDowngrade}
                        currentPlan={currentPlan}
                        selectedPlan={selectedPlan}
                        setSelectedPlan={setSelectedPlan}
                        hasErrorLoadingOptions={hasErrorLoadingOptions}
                        setHasErrorLoadingOptions={setHasErrorLoadingOptions}
                        subscriptionOptions={subscriptionOptions}
                        isLoading={isLoadingSubscriptionOptions}
                    />
                    <PaymentPage
                        maxAthleteCount={maxAthleteCount}
                        initialPlanSummary={initialPlanSummary}
                        clientToken={clientToken}
                        isLoading={isLoadingBraintreeDropIn}
                        setBraintreeInstance={setBraintreeInstance}
                        handleReviewPurchase={handleReviewPurchase}
                        isReviewPurchaseLoading={isReviewPurchaseLoading}
                        handleBack={handleBack}
                        errorMessage={errorMessage}
                        hasError={hasCreatePaymentMethodFailure}
                        clearBraintreeErrorMessage={clearBraintreeErrorMessage}
                    />
                    <ReviewPurchasePage
                        maxAthleteCount={maxAthleteCount}
                        finalPlanSummary={finalPlanSummary}
                        handleBack={handleBack}
                        isLoading={isLoadingBraintreeDropIn}
                        isPaymentProcessing={isPaymentProcessing}
                        handlePurchase={handlePurchase}
                    />
                </Checkout>
            </Box>
            <Footer />
            <SuccessDialog
                title="Success!"
                subtext={successMessage}
                isOpen={shouldShowSuccessDialog}
                handleClose={handleSuccessDialogClose}
            />
            <FailureDialog
                title={serverErrorTitle}
                subtext={serverErrorMessage}
                isOpen={hasServerError}
                handleClose={clearServerError}
            />
        </>
    );
}
